async function fetchDNM(path: string, params: string) {
  if (params) {
    try {
      const response = await fetch(`${path}?${params}`, {
        method: "GET",
        headers: {
          Accept: "application/json",
        },
        credentials: "include",
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error("Ошибка: ", error);
    }
  }
}

export async function getDNMData(params: string) {
  return fetchDNM("/internal-api/employee/compare", params);
}

export async function getDNMDataReport(params: string) {
  return fetchDNM("/internal-api/employee/compare/report", params);
}
